import {LocationService} from "../../services/LocationService";
import {ImportModel} from "./ImportModel";
import {Location} from "../../entities/Location"

export class LocationImportModel extends ImportModel<Location>  {
    static $inject = ['$q','LocationService'];
    name:string = "test";
    importType:string = "Location";

    constructor($q:ng.IQService, public locationService:LocationService){
        super($q,locationService);
    }
    getRoute(nextAction:string):string{
        return "admin.locationimport."+nextAction;
    }
}
